import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function PhoneNotification(props) {
  const { height, width, iconColor } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Atoms" fill="none" fillRule="evenodd">
        <g id="Icons/Filters/Notification/Black" transform="translate(-1 -4)" fill={iconColor}>
          <g id="Group-8" transform="translate(1 4)">
            <polygon
              id="Fill-1"
              points="18 4.0003 20 6.0003 18 8.0003 20 9.9993 18 12.0003 20.354 14.3543 21.061 13.6463 19.414 12.0003 21.414 9.9993 19.414 8.0003 21.414 6.0003 19.414 4.0003 21.061 2.3533 20.354 1.6463"
            />
            <polygon
              id="Fill-2"
              points="0.3537 2.3533 1.9997 4.0003 -0.0003 6.0003 1.9997 8.0003 -0.0003 9.9993 1.9997 12.0003 0.3537 13.6463 1.0597 14.3543 3.4137 12.0003 1.4137 9.9993 3.4137 8.0003 1.4137 6.0003 3.4137 4.0003 1.0597 1.6473"
            />
            <g id="Group-7" transform="translate(4)">
              <path
                d="M6.707,12.5 C6.432,12.5 6.207,12.275 6.207,12 C6.207,11.725 6.432,11.5 6.707,11.5 C6.982,11.5 7.207,11.725 7.207,12 C7.207,12.275 6.982,12.5 6.707,12.5 M6.707,10.5 C5.88,10.5 5.207,11.173 5.207,12 C5.207,12.827 5.88,13.5 6.707,13.5 C7.534,13.5 8.207,12.827 8.207,12 C8.207,11.173 7.534,10.5 6.707,10.5"
                id="Fill-3"
              />
              <path
                d="M1.9932,1 L4.7072,1 L4.7072,2 L8.7072,2 L8.7072,1 L11.4212,1 L11.4212,15 L1.9932,15 L1.9932,1 Z M5.5232,1 L5.5232,0.816 L7.8902,0.816 L7.8902,1 L7.8902,1.184 L5.5232,1.184 L5.5232,1 Z M0.9932,16 L12.4212,16 L12.4212,0 L0.9932,0 L0.9932,16 Z"
                id="Fill-5"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

PhoneNotification.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

PhoneNotification.defaultProps = {
  height: undefined,
  width: 22,
  iconColor: colors.colorGrey
};

export default PhoneNotification;
